<script>
  import { createEventDispatcher } from 'svelte';
  import { SHOT_DIRECTIONS } from '../../commentary-engine.js';

  const dispatch = createEventDispatcher();
  export let title = 'Select Shot Direction';

  function selectZone(dir) {
    dispatch('select', { direction: dir.short });
  }

  function skip() {
    dispatch('select', { direction: null });
  }

  function handleBackdropClick(event) {
    if (event.target === event.currentTarget) skip();
  }

  function handleModalKeydown(event) {
    if (event.key === 'Escape') skip();
  }
</script>

<svelte:window on:keydown={handleModalKeydown} />

<div class="modal-backdrop" role="presentation" on:click={handleBackdropClick}>
  <div class="modal-content" role="dialog" aria-modal="true" aria-label={title} tabindex="-1">
    <div class="modal-header">
      <h3 style="margin:0; font-size:16px; font-weight:800; color:#fbbf24;">🎯 {title}</h3>
      <button class="btn btn-ghost" style="padding:4px 8px; font-size:12px;" on:click={skip}>Skip ✕</button>
    </div>
    <div class="wagon-grid">
      {#each SHOT_DIRECTIONS as dir, i_each (i_each)}
        <button class="zone-btn" on:click={() => selectZone(dir)}>
          {dir.label}
        </button>
      {/each}
    </div>
  </div>
</div>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(2, 6, 23, 0.8);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 16px;
  }
  .modal-content {
    background: #0f172a;
    border: 1px solid rgba(251, 191, 36, 0.3);
    border-radius: 16px;
    padding: 16px;
    width: 100%;
    max-width: 360px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.5);
  }
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .wagon-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .zone-btn {
    background: rgba(30, 41, 59, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #f8fafc;
    padding: 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.15s ease;
  }
  .zone-btn:active {
    transform: scale(0.95);
    background: #fbbf24;
    color: #0f172a;
  }
</style>
